import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dialog",
    "outcome",
    "category",
    "title",
    "matchPath",
    "summary",
    "detail",
    "reportedAt",
    "sourceLink",
    "matchPathBlock",
    "detailBlock",
    "summaryBlock",
    "reportedAtBlock"
  ]

  open(event) {
    if (event.type === "keydown") event.preventDefault()

    const payload = event.params.payload
    if (!payload) return

    this.titleTarget.textContent = payload.title || ""
    this.outcomeTarget.textContent = payload.outcome_label || ""
    this.outcomeTarget.className = `tc-outcome tc-outcome--${payload.outcome || "neutral"}`
    this.categoryTarget.textContent = payload.category || ""

    if (payload.from_program && payload.to_program) {
      this.matchPathBlockTarget.hidden = false
      this.matchPathTarget.textContent = `${payload.from_program}${payload.from_tier ? ` ${payload.from_tier}` : ""} → ${payload.to_program}${payload.to_tier ? ` ${payload.to_tier}` : ""}`
    } else {
      this.matchPathBlockTarget.hidden = true
    }

    if (payload.summary) {
      this.summaryBlockTarget.hidden = false
      this.summaryTarget.textContent = payload.summary
    } else {
      this.summaryBlockTarget.hidden = true
    }

    if (payload.detail && payload.detail !== payload.summary) {
      this.detailBlockTarget.hidden = false
      this.detailTarget.textContent = payload.detail
    } else if (payload.detail && !payload.summary) {
      this.detailBlockTarget.hidden = false
      this.detailTarget.textContent = payload.detail
    } else {
      this.detailBlockTarget.hidden = true
    }

    if (payload.reported_at || payload.published_at) {
      this.reportedAtBlockTarget.hidden = false
      this.reportedAtTarget.textContent = payload.reported_at || payload.published_at
    } else {
      this.reportedAtBlockTarget.hidden = true
    }

    this.sourceLinkTarget.href = payload.url || "#"
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }
}
